import { api } from "../../api";

const GatewayInstructionActions = {
    async getGatewayInstructionsById({ commit }, gatewayId) {
        const data = await api.gateways.getInstructionsById(gatewayId);
        commit('setActiveGatewayInstructions', data);
    },
    async getGatewaysInstructions({ commit }) {
        const data = await api.gateways.getInstructions();
        commit('setGatewaysInstructions', data);
    },
    async saveGatewayInstructions({ state, commit }, gatewayId){
        const dto = state.activeGatewayInstructions.map(gi => ({
            instruction_name: gi.instructionName,
            parameters: gi.args,
        }));
        
        try {
            await api.gateways.saveInstructions(gatewayId, dto);
            commit('onSuccess');
        } catch (err) {
            commit('onFailure');
        }
    }
}

export default GatewayInstructionActions;